import { getApiUrl } from './apiConfig';
import { normalizeUserBreakVideoLinks } from './userBreakVideoLinks';

/** Resolve break id from course/grade row shapes. */
export function resolveBreakId(breakItem) {
  if (!breakItem || typeof breakItem !== 'object') return null;
  return breakItem.break_id ?? breakItem.id ?? null;
}

/**
 * Load existing user_break rows for append uploads (title suffix + link count).
 */
export async function fetchExistingUserBreakMeta(studentId, breakId) {
  let titleSuffix = '';
  let existingVideoCount = 0;
  try {
    const res = await fetch(
      `${getApiUrl()}/api/user-breaks?student_id=${encodeURIComponent(String(studentId))}&break_id=${encodeURIComponent(String(breakId))}`
    );
    if (!res.ok) return { titleSuffix, existingVideoCount };
    const existingRecords = await res.json();
    if (!Array.isArray(existingRecords) || existingRecords.length === 0) {
      return { titleSuffix, existingVideoCount };
    }
    const allLinks = [
      ...new Set(
        existingRecords.flatMap((row) => normalizeUserBreakVideoLinks(row.video_link))
      ),
    ];
    existingVideoCount = allLinks.length;
    if (allLinks.length > 0) {
      titleSuffix = ` ${allLinks.length + 1}`;
    }
  } catch {
    /* non-fatal */
  }
  return { titleSuffix, existingVideoCount };
}

/**
 * Append a YouTube URL to an existing user_break (or create one). Always POST — server upserts.
 */
export async function saveUserBreakWithVideo({
  studentId,
  breakId,
  youtubeUrl,
  completedDate,
}) {
  const saveRes = await fetch(`${getApiUrl()}/api/user-breaks`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      student_id: studentId,
      break_id: breakId,
      status: 'completed',
      completed_date: completedDate,
      video_link: youtubeUrl,
    }),
  });
  const saveData = await saveRes.json().catch(() => ({}));
  if (!saveRes.ok) {
    throw new Error(saveData.error || 'Could not save break record');
  }
  return saveData;
}
